<h1 class="hint">Download Ark7 Mobile APP</h1>

<div class="hint"
     *ngIf="isWechat; else downloading">
  <div>Please open this link in the system browser.</div>
</div>
<ng-template #downloading>
  <div class="hint">Redirecting to the App Store. If not, click <a href="{{downloadUrl}}">here</a> to
    try again.</div>
</ng-template>